import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../../firebase.init';
import MyItem from '../MyItem/MyItem';

const MyItems = () => {
    const [user] = useAuthState(auth);
    const [myItems, setMyItems] = useState([])
    const email = user.email;
    const url = `https://warehouse-management-server-30mo.onrender.com/product?email=${email}`;
    useEffect(() => {
        const getMyItems = async () => {
            const { data } = await axios.get(url, {
                headers: {
                    authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            })
            setMyItems(data)
        }
        getMyItems();
    }, [])

    return (
        <div style={{ backgroundColor: '#021B29', width: "83%" }} >
            <h3 className='text-white my-3'>All Of My Item</h3>
            <div>
                {
                    myItems.map(myitem => <MyItem
                        key={myitem._id}
                        myitem={myitem}
                    ></MyItem>)
                }
            </div>
        </div>
    );
};

export default MyItems;